export const isTimeValue = (value) =>
  typeof value === 'string' && /^([01]\d|2[0-3]):[0-5]\d$/.test(value);
export const formatTimeValue = (value, config = {}) => {
  if (value === null || value === undefined || value === '') return '-';
  if (!isTimeValue(value)) return 'Invalid time';
  if (config.clock_format !== '12h') return value;
  const [hour, minute] = value.split(':');
  return (
    (Number(hour) % 12 || 12) +
    ':' +
    minute +
    (Number(hour) < 12 ? ' AM' : ' PM')
  );
};
export const parseTimeInput = (value, config = {}) => {
  if (value === '' || isTimeValue(value)) return value;
  if (config.clock_format !== '12h') return isTimeValue(value) ? value : null;
  const match = /^(0?[1-9]|1[0-2]):([0-5]\d)\s*(AM|PM)$/i.exec(value.trim());
  if (!match) return null;
  const hour =
    (Number(match[1]) % 12) + (match[3].toUpperCase() === 'PM' ? 12 : 0);
  return String(hour).padStart(2, '0') + ':' + match[2];
};
export const validateTimeFields = (cards = [], values = {}) => {
  const errors = {};
  for (const card of cards)
    for (const item of card.items || []) {
      const value = values[item.field_id];
      if (
        item.field?.field_type === 'time' &&
        value !== null &&
        value !== undefined &&
        value !== '' &&
        !isTimeValue(value)
      )
        errors[item.field_id] = 'Enter a valid time.';
    }
  return errors;
};
